import { createFileRoute } from '@tanstack/react-router'
import { CreditCard } from 'lucide-react'
import { BillingScreen } from '@/screens/billing/SCR-053-billing'

export const Route = createFileRoute('/_app/billing/')({
  staticData: { screen: { id: 'SCR-053', title: 'Plan & billing', group: 'Organisation', perm: ['billing.read', 'billing.manage'], order: 10, eyebrow: 'Billing', description: 'Your plan, credits, next invoice and payment method.', icon: CreditCard } },
  component: BillingScreen,
})
